import { TemplateEngine } from "../../../../js/lib/TemplateEngine";
import { DialogManager } from "../../Managers/DialogManager";
import { ApplicationData } from "../ApplicationData";

export const SimpleErrorDialog = (function($) {
	
	var _show = function(content, callback) {
		callback = callback || function() {};
		DialogManager.show({
			content: 		content,
			dialogTitle: 	ApplicationData.language.errorDialogTitle,
			okText:			ApplicationData.language.ok,
			showCancel:		false,
			closeCallback: function(event) {
				callback();
			}
		});
	};

	return {
        /**
         *
         * @param {string} content a string message
         * @param {function()=} callback
         */
		show: function(content, callback) {
			_show(content, callback);
		},
        /**
         *
         * @param errors an array of error messages to display
         * @param callback
         */
		showValidationErrors: function(errors, callback) {
			var betterErrors = [];
			$.each(errors, function(index, message) {
				betterErrors.push({message: message});
			});
			TemplateEngine.compile("tmpl/validationError.html", {errors: betterErrors}, function(content) {
				_show(content, callback);
			})
		}
	}
})(jQuery);